import { ConfigApi, IdentityApi } from '@backstage/core-plugin-api';
import { AlertingApi } from './alerting-api';
import { AlertingResult } from '../../types/alerting';
import { Entity } from '@backstage/catalog-model';

export class AlertingApiClient implements AlertingApi {
  private readonly configApi;

  private readonly identityApi: IdentityApi;
  constructor(configApi: ConfigApi, identityApi: IdentityApi) {
    this.configApi = configApi;
    this.identityApi = identityApi;
  }
  async retrieveAlertingInfo(
    requestedEntity: Entity,
  ): Promise<AlertingResult[]> {
    const { token } = await this.identityApi.getCredentials();
    const url = this.configApi.getString('backend.baseUrl');
    const response = await fetch(
      `${url}/api/metricsAlertingInsights/v1/template/alerting`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ entity: requestedEntity }),
      },
    );
    if (!response.ok) {
      throw new Error(
        `Failed to retrieve alerting info, ${response.status} ${response.statusText}`,
      );
    }
    const data = await response.json();

    return data.alerts.alerts as AlertingResult[];
  }
}
